import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/opt/build/repo/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  "embedded-content-modal": defineAsyncComponent(() => import("/opt/build/repo/layouts/embedded-content-modal.vue").then(m => m.default || m))
}